/**
 * Created by Carsten Bühler
 * User: c.buehler on 04.10.2016
 * Copyright: xdot GmbH 2015
 */

import ClassNames from '../constants/ClassNames';

export function isLayerSet(layer) {
    return (layer.type === ClassNames.LayerSet);
}

export function isLogicalLayer(layer) {
    return (layer.type === ClassNames.LogicalLayer);
}

export function isLayerDataSource(layer) {
    return (layer.type === ClassNames.LayerDataSource);
}

export function loopLogicalLayerIds(layerSet, list) {
    layerSet.children.forEach((child) => {
        if (isLogicalLayer(child)) {
            list.push(child.uuid);
        } else if (isLayerSet(child)) {
            list = loopLogicalLayerIds(child, list);
        }
    });
    return list;
}

export function loopLogicalLayers(layerSet, list) {
    layerSet.children.forEach((child) => {
        if (isLogicalLayer(child)) {
            list.push(child);
        } else if (isLayerSet(child)) {
            list = loopLogicalLayers(child, list);
        }
    });
    return list;
}

export function findLogicalLayer(layerSet, id) {
    if (!isLayerSet(layerSet)) {
        return undefined;
    }
    for (const child of layerSet.children) {
        if (isLogicalLayer(child) && child.id === id) {
            return child;
        }
        if (isLayerSet(child)) {
            const found = findLogicalLayer(child, id);
            if (found !== undefined) {
                return found;
            }
        }
    }
    return undefined;
}

export function findLogicalLayerInSets(layerSets, id) {
    for (const ls of layerSets) {
        const ll = findLogicalLayer(ls, id);
        if (ll !== undefined) {
            return ll;
        }
    }
    return undefined;
}

function treeVisit(element, visitor) {
    const visit = e => {
        if ((visitor(e) !== false) && Array.isArray(e.children)) {
            e.children.forEach(visit);
        }
    };
    visit(element);
}

function filterElements(element, filter) {
    const result = [];
    element && (Array.isArray(element) ? element : [ element ])
        .forEach(element => treeVisit(element, e => (filter(e) && result.push(e)) || true));

    return result;
}

export function findAndSortLogicalLayers(element, logicalLayersPks) {
    return filterElements(element, e => isLogicalLayer(e) && (!logicalLayersPks || logicalLayersPks[ e.uuid ]))
        .sort((a, b) => {
            return ((a.zIndex > b.zIndex) ? 1 : ((a.zIndex < b.zIndex) ? -1 : 0));
        });
}

export function findLogicalLayersWithoutZIndex(element) {
    return filterElements(element, e => isLogicalLayer(e) && (!e.zIndex || (e.zIndex > 0 && e.zIndex === Number.MAX_VALUE)));
}

export function findAndSortLayerDataSource(element, layerUuids) {
    element = Array.isArray(element) ? element : [ element ];

    //find all LogicalLayer and sort it by zIndex
    const logicalLayer = findAndSortLogicalLayers(element, layerUuids);

    //collect all layerDataSources from logicalLayers
    const layerDataSources = [].concat.apply([], logicalLayer.map(ll => ll.children.filter(isLayerDataSource)));

    //collect all layerDataSources directly from element logicalLayers
    return layerDataSources.concat(element.filter(isLayerDataSource).filter(e => !layerUuids || layerUuids[ e.uuid ]));
}



// WEBPACK FOOTER //
// ./js/utils/map-config-util.js